<template>
    <div class="texticon">
        <van-icon :name="icon" :size="iconSize" :color="color"></van-icon>
        <span :style="{color:color, marginLeft: '4px', fontSize:textSize+'px'}">{{text}}</span>
    </div>
</template>

<script>
    export default {
        name: 'TextIcon',
        props: {
            textSize:{
                type: [Number, String],
                default () {
                    return "14"
                }
            },
            iconSize:{
                type: [Number, String],
                default () {
                    return "14"
                }
            },
            color:{
                type: String,
                default () {
                    return '#888'
                }
            },
            text:{
                type: [Number, String],
                default () {
                    return ''
                }
            },
            icon:{
                type: String,
                default () {
                    return ''
                }
            },
        },
        computed: {
        },
        methods: {
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .texticon{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
</style>
